import { render, staticRenderFns } from "./asset_borrow_record_dialog.vue?vue&type=template&id=657337fc"
import script from "./asset_borrow_record_dialog.vue?vue&type=script&lang=js"
export * from "./asset_borrow_record_dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports